import { OperationCheckTypes } from "../models/OperationCheckModels.js";
const GateStartBlockingOperations = [
  OperationCheckTypes.Start,
  OperationCheckTypes.Clone,
  OperationCheckTypes.Advance,
  OperationCheckTypes.Transfer
];
const GateStopBlockingOperations = [OperationCheckTypes.Stop, OperationCheckTypes.EmergencyStop];
const GateActionOperations = GateStartBlockingOperations.concat(GateStopBlockingOperations);
const GateUpdateOperations = [OperationCheckTypes.Update];
export {
  GateActionOperations,
  GateStartBlockingOperations,
  GateStopBlockingOperations,
  GateUpdateOperations
};
//# sourceMappingURL=GatingConstants.js.map
